/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABq0lEQVR4nN2Uu0oDURCGI6JiZ6Pi04hdisxlIyczQcEuRdrgUwia0kJsTR4iilhoYxMVhIj6AGoheCEgyiS7Scwm8eRSeWBgycl+//n/M7OJxL9ezrlZYM0A6RGy1oD1FUjq4XPJ9nK53MxIcGBJI+s9sn4PKmB9QNRgGPYUkBb/AmOsZM/e9Tn57vBwbbohLQ6Em9VR4RhWirLrPeF2WUjyOK4AsD4kk8m5+OmDjI4Lx7ZIpkf2WpqUAJKU4w5YaxNzQHoXFyD5mJgD1rd4RKTvI4A+w8nuciBPY0UEpM/Wjs65aeuYFGXzJtYU1ALR1kKviMr+XSLp7vdTnF21SvRbRCK+sTjnpsNDnQHLRdK5xYhjz8B6gqwHsS+n18eNpB4NEpJeho6qBrZC0qtwFo573INs+7hIUTZv/w+CzSVkuY5EIrj9Znu/4A1rpHe+MSFm1loiLXDj5LdBsLHSHc88kp4P054YCnTG0lcAWPaHnNRC+0KlGsXSjktvAHS5cwZ2gOTLT0Beoj5HkkoEN6DFFQkC62nflvVdwHpooM4LbUYmFdsbW8Bn/QCuNpt7PQhVJgAAAABJRU5ErkJggg==)
 */
export const ChatXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 15.3a1 1 0 0 1 1.4 0l2.3 2.29 2.3-2.3a1 1 0 0 1 1.4 1.42L20.43 19l2.29 2.3a1 1 0 0 1-1.42 1.4L19 20.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L17.58 19l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m18.65 14.4-.53-.52a3 3 0 1 0-4.24 4.24l.53.53c.2.2.2.5 0 .7l-.53.53a2.99 2.99 0 0 0-.84 1.63c-.04.25-.23.46-.48.47L12 22H2.2a1 1 0 0 1-.75-1.66l2.07-2.37a.52.52 0 0 0 .04-.61 10 10 0 1 1 18.43-4.8c-.02.25-.23.44-.48.48-.6.1-1.17.38-1.63.84l-.52.52a.5.5 0 0 1-.71 0Z"
        className={colorClass}
      />
    </svg>
  );
};
